import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import * as Funciones from "../../funciones/FuncionesFecha";
import DatePicker from "react-datepicker";
import styles from "./CampoEditableFecha.module.css";


const CampoEditableFecha = (props) => {
  const estilo = props.estilo;
  const editar = props.editar;
  const nombre = props.nombre;
  const fecha = props.valor;

  const onChangeHandler = (valor) => {
    let fechaCambiada = valor;
    if (Funciones.EsFechaValida(valor)) {
      fechaCambiada = Funciones.DateToArray(valor);
    }
    props.onChange(nombre, fechaCambiada);
  };

  let campo = "";
  if (editar) {
    campo = (
      <DatePicker
        className={`${styles.campoFecha} ${estilo}`}
        key={nombre}
        selected={Funciones.ArrayToDate(fecha)}
        dateFormat="dd/MM/yyyy"
        utcOffset={0}
        onChange={onChangeHandler}
      />
    );
  } else {
    campo = fecha ? Funciones.FechaCorta(fecha) : "";
  }

  return <React.Fragment>{campo}</React.Fragment>;
};

export default CampoEditableFecha;
